var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
// Utils
import { getInvalidStateMachineActionError } from '../../errors/getInvalidStateMachineActionError';
export var createStateMachine = function (_a) {
    var initialState = _a.initialState, stateTransitions = _a.stateTransitions, initialContext = _a.initialContext;
    var currentState = initialState;
    var context = initialContext;
    var listeners = [];
    var notifyListeners = function () {
        var e_1, _a;
        try {
            for (var listeners_1 = __values(listeners), listeners_1_1 = listeners_1.next(); !listeners_1_1.done; listeners_1_1 = listeners_1.next()) {
                var listener = listeners_1_1.value;
                listener(currentState);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (listeners_1_1 && !listeners_1_1.done && (_a = listeners_1.return)) _a.call(listeners_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    var setContext = function (getNewContextValues) {
        context = getNewContextValues(context);
        return context;
    };
    var performAction = function (_a) {
        var action = _a.action, payload = _a.payload;
        return __awaiter(void 0, void 0, void 0, function () {
            var transition, toState, actionHandler;
            var _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        transition = (_b = stateTransitions[currentState]) === null || _b === void 0 ? void 0 : _b[action];
                        if (!transition) {
                            throw getInvalidStateMachineActionError(action, currentState);
                        }
                        toState = transition.toState, actionHandler = transition.actionHandler;
                        if (!stateTransitions[toState]) return [3 /*break*/, 2];
                        currentState = toState;
                        notifyListeners();
                        if (!actionHandler) return [3 /*break*/, 2];
                        return [4 /*yield*/, actionHandler({ performAction: performAction, context: context, setContext: setContext, payload: payload })];
                    case 1:
                        _c.sent();
                        _c.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    return {
        performAction: performAction,
        getCurrentState: function () { return currentState; },
        subscribe: function (newListener) {
            listeners.push(newListener);
            return function () {
                listeners = listeners.filter(function (listener) { return listener !== newListener; });
            };
        },
    };
};
//# sourceMappingURL=createStateMachine.js.map